import { TextField } from '@mui/material'
import { type Control, Controller } from 'react-hook-form'

import { Box } from '@/components/ui'

import {
  type CreateOrgFormValues,
  DISPLAY_NAME_MAX_LENGTH,
  ORG_NAME_MIN_LENGTH,
} from '../definitions/createOrganizationForm'

interface BasicInfoStepProps {
  control: Control<CreateOrgFormValues>
}

const ORG_NAME_HELPER_TEXT = `Internal name, at least ${ORG_NAME_MIN_LENGTH} characters. Not shown to the practice.`

export const BasicInfoStep = ({ control }: BasicInfoStepProps) => (
  <Box variant='flexColumn' gap='md'>
    <Controller
      name='org_name'
      control={control}
      rules={{
        validate: (value) =>
          value.trim().length >= ORG_NAME_MIN_LENGTH ||
          `Must be at least ${ORG_NAME_MIN_LENGTH} characters.`,
      }}
      render={({ field, fieldState }) => (
        <TextField
          {...field}
          label='Organization Name'
          placeholder='Acme Healthcare Group'
          required
          fullWidth
          error={fieldState.invalid}
          helperText={fieldState.error?.message ?? ORG_NAME_HELPER_TEXT}
        />
      )}
    />
    <Controller
      name='display_name'
      control={control}
      rules={{
        validate: (value) => value.trim().length > 0 || 'Required.',
      }}
      render={({ field, fieldState }) => (
        <TextField
          {...field}
          label='Display Name'
          placeholder='Acme Healthcare'
          required
          fullWidth
          error={fieldState.invalid}
          helperText={
            fieldState.error?.message ??
            `Shown to the practice. Up to ${DISPLAY_NAME_MAX_LENGTH} characters.`
          }
          slotProps={{ htmlInput: { maxLength: DISPLAY_NAME_MAX_LENGTH } }}
        />
      )}
    />
  </Box>
)
